<main class="container my-5 pt-5">
  <div class="container-fluid main-content">
    <div class="custom-card">
      <div class="card-body d-flex row justify-content-center">
        <h2 class="custom-card-title text-center pb-4">Acknowledgements</h2>

        <div class="text-center">
          <a href="https://gwinnettcb.org">
            <img src="./assets/ggc-black-and-green-logo.png" alt="GGC Black Logo" class="img-fluid">
          </a>
        </div>
        <div class="px-5 mt-4">
          <p>
            Georgia Gwinnett College provides access to targeted baccalaureate and associate level degrees that meet
            the economic development needs of the
            growing and diverse population of the northeast Atlanta metropolitan region. It emphasizes the innovative
            use of technology and active-learning
            environments to provide its students enhanced learning experiences, practical opportunities to apply
            knowledge, increased scheduling flexibility,
            and a variety of course delivery options. Georgia Gwinnett’s outstanding faculty and staff actively engage
            students in various learning environments,
            serve as mentors and advisors, and assist students through programs designed to enhance their academic,
            social, and personal development. GGC produces
            contributing citizens and future leaders for Georgia and the nation. Its graduates are inspired to
            contribute to the local, state, national, and
            international communities and are prepared to anticipate and respond effectively to an uncertain and
            changing world.
          </p>
          <div id="links">
            <a href="https://www.ggc.edu/academics/schools/school-of-science-and-technology" target="_blank"
               style="text-decoration: underline; text-decoration-skip-ink: auto; margin-right: 0.5rem;">
              The School of Science and Technology (SST) provides innovative programs in science, math and technology.
            </a> <br>
            <a href="https://www.ggc.edu/academics/school-of-science-and-technology/information-technology"
               target="_blank" style="text-decoration: underline; text-decoration-skip-ink: auto;">
              Information technology (IT) is the multidisciplinary study, design, development, implementation, support
              or management of computer-based information systems, particularly software applications and system
              networks.
            </a>
          </div>
        </div>

        <div>
          <div class="px-5" style="padding-top: 0.5rem;">
            <h5 class="fw-bold mb-0 mt-4">World Wildlife Fund (WWF)</h5><br/>
            <a href="https://gwinnettcb.org">
              <img id="wwf" src="./assets/WWF_Logo.png" alt="GGC Black Logo" class="float-start img-fluid">
            </a>

            <p class="d-inline">
              WWF is one of the world’s leading conservation organizations, working for 60 years in nearly 100 countries
              to help people and nature thrive.
              With the support of 1 million members in the United States and more than 5 million members worldwide, WWF
              is dedicated to delivering
              science-based solutions to preserve the diversity and abundance of life on Earth, halt the degradation of
              the environment, and combat the climate
              crisis. WWF and GC&B are partnering to implement and expand a hands-on, sustainability-focused program in
              local schools to tackle waste and encourage
              environmental sustainability among students.
            </p></div>
        </div>

        <h2 class="custom-card-title mb-3 mt-4 text-center">
          Built & Maintained by Georgia Gwinnett College
        </h2>
        <div class="row text-center align-items-center justify-content-center text-center">
          <div class="col-md-4 mb-3">
            <h5 class="fw-bold mb-0">Dr. Anca Doloc-Mihu</h5>
            <h6 class="fw-normal mb-0">Intern Supervisor and Course Instructor</h6>
            <a href="https://www.linkedin.com/in/anca-doloc-mihu-359aa312/">LinkedIn</a>
          </div>
          <div class="col-md-4 mb-3">
            <h5 class="fw-bold mb-0">Dr. Cengiz Gunay</h5>
            <h6 class="fw-normal mb-0">Intern Supervisor</h6>
            <a href="https://www.linkedin.com/in/cengiz-gunay-5010a89/">LinkedIn</a>
          </div>
        </div>
        <div class="row text-center align-items-center justify-content-center">
          <div *ngFor="let member of makers" class="col-md-4 mb-3">
            <h5 class="fw-bold mb-0">{{ member.name }}</h5>
            <h6 class="fw-normal mb-0">{{ member.role }}</h6>
            <a [href]=member.linkedIn>LinkedIn</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
